export default [
    {
        name: 'Activity',
        children: [
            { name: 'Colors', component: () => import(/* webpackChunkName: "storybook" */ './activity/colors') },
            {
                name: 'Knob Jobs',
                component: () => import(/* webpackChunkName "storybook" */ './activity/knob-jobs'),
            },
        ],
    },
    {
        name: 'Autocomplete',
        children: [
            {
                name: 'Static',
                component: () => import(/* webpackChunkName "storybook" */ './autocomplete/static-autocomplete'),
            },
        ],
    },
    {
        name: 'Avatars',
        children: [
            {
                name: 'Company',
                component: () => import(/* webpackChunkName "storybook" */ './avatars/company'),
            },
            {
                name: 'Executive',
                component: () => import(/* webpackChunkName "storybook" */ './avatars/executive'),
            },
        ],
    },
    {
        name: 'Popovers',
        children: [
            {
                name: 'Executive',
                component: () => import(/* webpackChunkName "storybook" */ './popovers/executive-popover'),
            },
        ],
    },
    { name: 'Breadcrumbs', component: () => import(/* webpackChunkName "storybook" */ './breadcrumbs') },
    { name: 'Buttons', component: () => import(/* webpackChunkName "storybook" */ './buttons') },
    {
        name: 'Charts',
        children: [
            {
                name: 'Doughnut Chart',
                component: () => import(/* webpackChunkName: "storybook" */ './charts/doughnut'),
            },
            {
                name: 'Rating Range',
                children: [
                    {
                        name: 'Bar',
                        component: () => import(/* webpackChunkName: "storybook" */ './charts/rating-range/bar'),
                    },
                ],
            },
            {
                name: 'Stock Price Line',
                component: () => import(/* webpackChunkName: "storybook" */ './charts/stock-price-line'),
            },
            {
                name: 'Trailing Chart',
                component: () => import(/* webpackChunkName: "storybook" */ './charts/TrailingChart'),
            },
            {
                name: 'Chart JS',
                children: [
                    {
                        name: '90 Day Chart',
                        component: () => import(/* webpackChunkName: "storybook" */ './charts/chartJS/90-days'),
                    },
                    {
                        name: 'Bar',
                        component: () => import(/* webpackChunkName: "storybook" */ './charts/chartJS/bar'),
                    },
                    {
                        name: 'Circle Stat',
                        component: () => import(/* webpackChunkName: "storybook" */ './charts/chartJS/circle-stat'),
                    },
                    {
                        name: 'Combo Chart',
                        component: () => import(/* webpackChunkName: "storybook" */ './charts/chartJS/combo'),
                    },
                    {
                        name: 'Horizontal Bar',
                        component: () => import(/* webpackChunkName: "storybook" */ './charts/chartJS/bar-horizontal'),
                    },
                    {
                        name: 'Large Stat',
                        component: () => import(/* webpackChunkName: "storybook" */ './charts/chartJS/large-stat'),
                    },
                    {
                        name: 'Line Chart',
                        component: () => import(/* webpackChunkName: "storybook" */ './charts/chartJS/line'),
                    },
                    {
                        name: 'Pie Chart',
                        component: () => import(/* webpackChunkName: "storybook" */ './charts/chartJS/pie'),
                    },
                ],
            },
        ],
    },
    {
        name: 'Custom Work',
        children: [
            {
                name: 'Modal',
                component: () => import(/* webpackChunkName "storybook" */ './CustomWork/CustomWorkModal.vue'),
            },
        ],
    },
    {
        name: 'Executive',
        children: [
            {
                name: 'Capital Allocation Table',
                component: () => import(/* webpackChunkName "storybook" */ './executives/capital-allocation-table'),
            },
            {
                name: 'Executives Capital Allocations Table',
                component: () =>
                    import(/* webpackChunkName "storybook" */ './executives/executives-capital-allocations-table'),
            },
            {
                name: 'Overall Rating Trailing Chart',
                component: () =>
                    import(/* webpackChunkName "storybook" */ './executives/overall-rating-trailing-chart.vue'),
            },
        ],
    },
    {
        name: 'Dashboard',
        children: [
            {
                name: 'Statistics Block',
                component: () => import(/* webpackChunkName "storybook" */ './dashboard/statistics-block'),
            },
        ],
    },
    {
        name: 'Filters',
        children: [
            {
                name: 'Date Range',
                component: () => import(/* webpackChunkName "storybook" */ './filters/date-range'),
            },
            {
                name: 'Filter Group',
                component: () => import(/* webpackChunkName "storybook" */ './filters/filter-group'),
            },
            {
                name: 'Stacked Bar Filter',
                component: () => import(/* webpackChunkName "storybook" */ './filters/stacked-bar-filter'),
            },
        ],
    },
    { name: 'Headings', component: () => import(/* webpackChunkName "storybook" */ './headings') },
    {
        name: 'Inputs',
        children: [
            {
                name: 'Calendar',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/Calendar.vue'),
            },
            {
                name: 'Checkbox',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/checkbox'),
            },
            {
                name: 'Cropper',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/cropper'),
            },
            {
                name: 'Image Picker',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/image-picker'),
            },
            {
                name: 'Radio',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/radio'),
            },
            {
                name: 'Rich Text Editor',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/rich-text-editor'),
            },
            {
                name: 'Select',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/select'),
            },
            {
                name: 'Sheet Editor',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/SheetEditor'),
            },
            {
                name: 'Slider',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/slider'),
            },
            {
                name: 'Switch',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/switch'),
            },
            {
                name: 'Text',
                component: () => import(/* webpackChunkName "storybook" */ './inputs/text'),
            },
        ],
    },
    {
        name: 'Tables',
        children: [
            {
                name: 'Empty Template',
                component: () => import(/* webpackChunkName "storybook" */ './tables/empty-template'),
            },
            {
                name: 'With Details',
                component: () => import(/* webpackChunkName "storybook" */ './tables/with-details'),
            },
        ],
    },
    {
        name: 'Tabs',
        children: [
            {
                name: 'Light',
                component: () => import(/* webpackChunkName "storybook" */ './tabs/light'),
            },
            {
                name: 'Regular',
                component: () => import(/* webpackChunkName "storybook" */ './tabs/regular'),
            },
        ],
    },
    {
        name: 'Premium Research',
        children: [
            {
                name: 'MT Hero Banner',
                component: () => import(/* webpackChunkName "storybook" */ './ceo-change/ceo-change-mt-banner'),
            },
        ],
    },
]
